import React from 'react';

import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  BooleanField,
  EditButton,
  ReferenceField,
  Filter,
  SearchInput,
  ReferenceInput,
  SelectInput
} from "react-admin";

const Filters = props => (
  <Filter {...props}>
    <SearchInput source="rfqNo~like" label="RFQ No" alwaysOn />
    <SearchInput source="agent~like" label="Agent" alwaysOn />
    <SearchInput source="customer~like" label="Customer" alwaysOn />
    <ReferenceInput
      label="RM"
      source="rmid"
      reference="employees"
      filter={{ typeid: 98 }}
      perPage={1000}
      sort={{ field: 'name', order: 'ASC' }}
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>

    <ReferenceInput
      label="Status"
      source="statusId"
       perPage={1000}
      reference="lookups"
      filter={{ type: 'RFQST' }}
      sort={{ field: 'name', order: 'ASC' }}
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export const RfqRegisterList = (props) => (

  <List
    {...props}
    filters={<Filters />}
    title="RFQ Register List"
    sort={{ field: 'id', order: 'DESC' }}
  >

    <Datagrid rowClick="edit">

      <EditButton />

      <TextField source="rfqNo" label="RFQ No" />

      <DateField source="receivedDate" label="Received Date"  locales="fr-FR" />

      <DateField source="floatDate" label="Float Date"  locales="fr-FR" />

      <TextField source="agent" label="Agent" />

      <TextField source="customer" label="Customer" />

      <ReferenceField
        source="policyTypeId"
        reference="policy-departments"
        label="Policy Type"
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>

      <ReferenceField
        source="rmid"
        reference="employees"
        label="RM"
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>

      <NumberField source="sumInsured" label="Sum Insured" />

      <NumberField source="finalisedPremium" label="Finalised Premium" />

      <ReferenceField
        source="statusId"
        reference="lookups"
        label="Status"
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>

      <BooleanField source="isActive" label="Active" />

    </Datagrid>

  </List>
);